import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {
  ApartmentRounded,
  AttachMoneyRounded,
  ArrowDropDownCircleOutlined,
  Percent,
  CollectionsBookmarkOutlined,
  MapOutlined,
} from '@mui/icons-material';
import SchoolIcon from '@mui/icons-material/School';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { data } from '../../data/demo';
import { Bar, Doughnut } from 'react-chartjs-2';
import { Paper } from '@mui/material';
import Chart from '../Charts';
import { dropOutData } from '../../data/dropout';
import {studentData} from '../../data/studentData';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function SubMenu({ label1, label2 }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Tabs
      
        value={value}
        onChange={handleChange}
        aria-label='icon label tabs example'
        style={{
          paddingTop: "60px",
          maxHeight: '100vh',
          
          
        }}
        sx={{
          justifyContent: "center",
        }}
      
      >
        <Tab icon={<Percent />} label={label1} {...a11yProps(0)} />
        <Tab
          icon={<ArrowDropDownCircleOutlined />}
          label={label2}
          sx={{
            justifyContent: "center",
          }}
        
          {...a11yProps(1)}
        />
      </Tabs>
      
      <Box display='flex' width={400} sx={{
    justifyContent: "center",
  }}
>
        <TabPanel value={value} index={0}>
          <Typography
            variant='h6'
            color='primary'
            styles={{ alignItems: 'center' }}
          >
            Government Sponsored
          </Typography>
          <Doughnut data={data} />
        </TabPanel>

        <TabPanel value={value} index={0} sx={{
    justifyContent: "center",
  }}
>
          <Typography
            variant='h6'
            color='primary'
            styles={{ alignItems: 'center' }}
          >
            Private Sponsored
          </Typography>
          <Doughnut data={studentData} />
        </TabPanel>
      </Box>

      <TabPanel value={value} index={1}>
        <Paper
          sx={{
            p: 1,
            display: 'flex',
            flexDirection: 'column',
            height: 350,
          }}
        >
          <Bar data={dropOutData} />
        </Paper>

        <TabPanel
          value={value}
          index={0}
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <Doughnut data={data} />;
        </TabPanel>

      </TabPanel>
    </Box>
  );
}
